import React from "react";
import { Routes, Route } from "react-router-dom";
import { AtivosMercado, Ativo } from "../../../pagesPublic";

const MercadosRoutes = () => {
  console.log("here!");
  return (
    <Routes>
      <Route exact path={"/page/:page"} element={<AtivosMercado />} />
      <Route exact path={`:id/*`} element={<Ativo />} />
      <Route path={"*"} element={<AtivosMercado />} />
    </Routes>
  );
};

export default MercadosRoutes;
